module.exports = __webpack_public_path__ + "static/Chubb-d76ceaa47834539a2d32df4d086fc00b.png";